import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-20">
        <section className="py-20 md:py-28 bg-background-50">
          <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
              Page Not Found
            </span>
            <h1 className="text-5xl md:text-6xl font-heading font-bold text-foreground-950 mb-4">
              404
            </h1>
            <p className="text-base md:text-lg text-foreground-600 mb-8 leading-relaxed">
              The page you are looking for does not exist or has been moved. Let&apos;s get you back to our BaseTao Spreadsheet resources.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Back to Homepage
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-left-line text-sm"></i>
                </div>
              </Link>
              <Link
                to="/basetao-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read the Complete Guide
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-book-open-line text-sm"></i>
                </div>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}